module.exports = __webpack_public_path__ + "static/media/solve.40d40fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/homepage/solve.png
// module id = 871
// module chunks = 21